import React, { useState } from "react";
import GalleryHero from "./components/GalleryHero";
import BeautyGalleryManager from "./components/BeautyGalleryManager";


const Gallery = () => {
  // Define tabs for the Flavours admin panel
  const TABS = {
    hero: "GalleryHero",
    beauti: "GalleryBeauty",
  };

  // Default to the Hero tab
  const [activeTab, setActiveTab] = useState(TABS.hero);

  // Function to switch tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 space-y-8">
      {/* Top Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button
          onClick={() => handleTabChange(TABS.hero)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.hero
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Gallery Hero
        </button>
        <button
          onClick={() => handleTabChange(TABS.beauti)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.beauti
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Gallery Beauty
        </button>
      </div>

      {/* Render selected component */}
      <div className="bg-gray-50 p-4 rounded shadow">
        {activeTab === TABS.hero && <GalleryHero />}
        {activeTab === TABS.beauti && <BeautyGalleryManager />}
      </div>
    </div>
  );
};

export default Gallery;